module.exports = __webpack_public_path__ + "media/images/hapier2-0dc4748e60f2f015b4f3d8db6c40eab2.png";